import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var FastForward = createReactComponent("FastForward", ["svg", defaultAttributes, [["polygon", {
  points: "13 19 22 12 13 5 13 19",
  key: "6wx0cv"
}], ["polygon", {
  points: "2 19 11 12 2 5 2 19",
  key: "1qmptp"
}]]]);
export default FastForward;